import {
  TOGGLE_COLLAPSED_NAV,
  CHANGE_LOCALE,
  SIDE_NAV_STYLE_CHANGE,
  NAV_TYPE_CHANGE,
  TOP_NAV_COLOR_CHANGE,
  HEADER_NAV_COLOR_CHANGE,
  TOGGLE_MOBILE_NAV,
  SWITCH_THEME,
  DIRECTION_CHANGE
} from '../constants/Theme';

import { THEME_CONFIG } from 'configs/AppConfig'

const initTheme = {
  ...THEME_CONFIG
};
const theme = (setting = initTheme, action) => {
  switch (action.type) {
    case TOGGLE_COLLAPSED_NAV:
      return {
        ...setting,
        navCollapsed: action.navCollapsed
      };
    case SIDE_NAV_STYLE_CHANGE:
      return {
        ...setting,
        sideNavTheme: action.sideNavTheme
      };
    case CHANGE_LOCALE:
      return {
        ...setting,
        locale: action.locale
      };
    case NAV_TYPE_CHANGE:
      return {
        ...setting,
        navType: action.navType
      };
    case TOP_NAV_COLOR_CHANGE:
      return {
        ...setting,
        topNavColor: action.topNavColor
      };
    case HEADER_NAV_COLOR_CHANGE:
      return {
        ...setting,
        headerNavColor: action.headerNavColor
      };
    case TOGGLE_MOBILE_NAV:
      return {
        ...setting,
        mobileNav: action.mobileNav
      };
    case SWITCH_THEME:
      return {
        ...setting,
        currentTheme: action.currentTheme
      }
    case DIRECTION_CHANGE:
      return {
        ...setting,
        direction: action.direction
      }
    default:
      return setting;
  }
};

export default theme